import React from "react";
import {
  makeStyles,
  shorthands,
  tokens,
  Text,
  Divider,
} from "@fluentui/react-components";
import { t } from "../../i18n/i18n";

const useStyles = makeStyles({
  contentWrapper: {
    "@media screen and (max-width: 700px)": {
      display: "none",
    },
    width: "60%",
    marginTop: "60px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  iconWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    rowGap: tokens.spacingVerticalM,
  },
  symbolWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  symbol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...shorthands.margin(
      "0 auto",
      tokens.spacingHorizontalL,
      tokens.spacingVerticalM,
      "auto"
    ),

    fontSize: tokens.fontSizeBase500,
    textAlign: "center",

    height: "60px",
    minWidth: "60px",

    boxShadow: tokens.shadow16,

    backgroundColor: tokens.colorBrandBackground,

    ...shorthands.borderRadius("50%"),
  },
  symbolActive: {
    backgroundColor: "#C9E3FF",
    color: tokens.colorBrandBackground,
  },
  whiteColor: {
    color: "#ffffff",
  },
  activeColor: {
    color: tokens.colorBrandBackground,
  },
  divider: {
    ...shorthands.margin(0, tokens.spacingHorizontalL),
    width: "100%",
  },
});

type OrderHeaderProps = {
  step?: number;
};
export const OrderHeader = ({ step }: OrderHeaderProps) => {
  const classes = useStyles();
  return (
    <section className={classes.contentWrapper}>
      {/* Information symbol 1 */}
      <div className={classes.symbolWrapper}>
        <div
          className={
            step === 1
              ? `${classes.symbol} ${classes.symbolActive}`
              : classes.symbol
          }
        >
          <Text
            size={700}
            weight="semibold"
            className={step === 1 ? classes.activeColor : classes.whiteColor}
          >
            1
          </Text>
        </div>
        <Text size={500} weight="bold">
          {t("Information")}
        </Text>
      </div>

      <Divider appearance="brand" className={classes.divider} />

      {/* Beställ symbol 2 */}
      <div className={classes.symbolWrapper}>
        <div
          className={
            step === 3
              ? `${classes.symbol} ${classes.symbolActive}`
              : classes.symbol
          }
        >
          <Text
            size={700}
            weight="semibold"
            className={step === 3 ? classes.activeColor : classes.whiteColor}
          >
            2
          </Text>
        </div>
        <Text size={500} weight="bold">
          {t("Order")}
        </Text>
      </div>
    </section>
  );
};
